import { useRef } from 'react';
import { FaCheckCircle } from 'react-icons/fa';
import useIntersectionObserver from '../hooks/useIntersectionObserver';
import './Choose.css';

const whyChooseItems = [
  { text: 'All-in-One: Recharges, bills, loans & more in one app.', color: '#F6A10D', icon: <FaCheckCircle size={24} /> },
  { text: 'Super Fast: Instant confirmations every time.', color: '#f093fb', icon: <FaCheckCircle size={24} /> },
  { text: 'Smart Wallet: Use wallet + UPI together for flexible payments.', color: '#4fd1c5', icon: <FaCheckCircle size={24} /> },
  { text: 'Trusted by Users: Safe, secure, and transparent.', color: '#667eea', icon: <FaCheckCircle size={24} /> },
  { text: '24/7 Customer Support: Help is always available.', color: '#F6A10D', icon: <FaCheckCircle size={24} /> },
  { text: 'Exciting Cashback & Rewards on every transaction.', color: '#f093fb', icon: <FaCheckCircle size={24} /> },
];

function Choose() {
  const { sectionRef, isVisible } = useIntersectionObserver();

  return (
    <section className="choose-section" ref={sectionRef}>
      <div className="choose-container">
        
        <h2 className={`choose-title ${isVisible ? 'animate' : ''}`}>Why Choose RSKPay?</h2>
        
        <div className="choose-content">
          {/* Left side - First 3 items */}
          <ul className="choose-list choose-list-left">
            {whyChooseItems.slice(0, 3).map((item, idx) => (
              <li key={idx} className={`choose-item ${isVisible ? 'slide-in' : ''}`} style={{ animationDelay: `${idx * 0.1}s` }}>
                <div className="icon-wrapper">
                  {item.icon}
                </div>
                <span>{item.text}</span>
              </li>
            ))}
          </ul>

          {/* SVG Graphic - Center */}
          <div className="choose-graphic">
            <svg width="300" height="300" viewBox="0 0 300 300" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <linearGradient id="chooseGradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" style={{ stopColor: '#F6A10D', stopOpacity: 0.8 }} />
                  <stop offset="100%" style={{ stopColor: '#4fd1c5', stopOpacity: 0.8 }} />
                </linearGradient>
                <linearGradient id="chooseGradient2" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" style={{ stopColor: '#f093fb', stopOpacity: 0.8 }} />
                  <stop offset="100%" style={{ stopColor: '#667eea', stopOpacity: 0.8 }} />
                </linearGradient>
                <filter id="glow1">
                  <feGaussianBlur stdDeviation="3" result="coloredBlur"/>
                  <feMerge>
                    <feMergeNode in="coloredBlur"/>
                    <feMergeNode in="SourceGraphic"/>
                  </feMerge>
                </filter>
              </defs>
              
              {/* Central circle with pulse animation */}
              <circle cx="150" cy="150" r="80" fill="url(#chooseGradient1)" opacity="0.2" className="pulse-circle"/>
              <circle cx="150" cy="150" r="60" fill="url(#chooseGradient1)" opacity="0.3" className="pulse-circle-2"/>
              
              {/* Rotating orbiting circles */}
              <g className="orbit-group">
                <circle cx="150" cy="70" r="15" fill="#F6A10D" filter="url(#glow1)" opacity="0.9"/>
                <circle cx="230" cy="110" r="12" fill="#4fd1c5" filter="url(#glow1)" opacity="0.9"/>
                <circle cx="230" cy="190" r="15" fill="#f093fb" filter="url(#glow1)" opacity="0.9"/>
                <circle cx="150" cy="230" r="12" fill="#667eea" filter="url(#glow1)" opacity="0.9"/>
                <circle cx="70" cy="190" r="15" fill="#F6A10D" filter="url(#glow1)" opacity="0.9"/>
                <circle cx="70" cy="110" r="12" fill="#f093fb" filter="url(#glow1)" opacity="0.9"/>
              </g>
              
              {/* Center icon placeholder */}
              <circle cx="150" cy="150" r="40" fill="url(#chooseGradient2)" opacity="0.4"/>
              <path d="M150 130 L160 145 L175 125" stroke="#ffffff" strokeWidth="4" fill="none" strokeLinecap="round" strokeLinejoin="round" className="check-mark"/>
            </svg>
          </div>

          {/* Right side - Last 3 items */}
          <ul className="choose-list choose-list-right">
            {whyChooseItems.slice(3, 6).map((item, idx) => (
              <li key={idx + 3} className={`choose-item ${isVisible ? 'slide-in' : ''}`} style={{ animationDelay: `${(idx + 3) * 0.1}s` }}>
                <div className="icon-wrapper">
                  {item.icon}
                </div>
                <span>{item.text}</span>
              </li>
            ))}
          </ul>
        </div>

      </div>
    </section>
  );
}

export default Choose;
